<div class="footer">
  <div class="container">
    <div id="info" class="copyright">
      <span> © Capital Soft {{ currentYear }}</span>
    </div>
    <div id="social-icons">
      <ul>
        <li>
          <a href="https://www.linkedin.com/company/capitalsoft-armenia/" target="_blank">
            <i class="fab fa-linkedin-in"></i>
          </a>
        </li>
        <li>
          <a href="mailto:contact@capitalsoft.am" target="_blank">
            <i class="far fa-envelope"></i>
          </a>
        </li>
        <li>
          <a href="https://www.facebook.com/capitalsoft.am/" target="_blank">
            <i class="fab fa-facebook-f"></i>
          </a>
        </li>
      </ul>
    </div>
  </div>
</div>
